import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--color-gray-07)",
      "fill-rule": "evenodd",
      d: "M10.004 3.25a1.75 1.75 0 0 1 0 3.5h-.009a1.75 1.75 0 1 1 0-3.5zm0 10a1.75 1.75 0 0 1 0 3.5h-.009a1.75 1.75 0 1 1 0-3.5zm1.75-3.25a1.75 1.75 0 0 0-1.75-1.75h-.009a1.75 1.75 0 1 0 0 3.5h.009a1.75 1.75 0 0 0 1.75-1.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }